import axios from "axios"

export const deleteUtenteMaster = (id: number) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(`/api/UtenteMaster/${id}`)
      .then(() => {
        resolve(true)
      })
      .catch((error) => {
        reject(error.response.data.response)
      })
  })
}
export default deleteUtenteMaster
